import React, { useState, useEffect } from 'react';

const getTargetImagePath = (card) => {
  if (!card) return null;

  const colorInitials = { blue: "B", red: "R", green: "G", yellow: "Y", black: "W" };
  const initial = colorInitials[card.color?.toLowerCase()] || "X";

  if (card.type === "number") return `/cards/${initial}${card.value}.png`;

  if (card.type === "action") {
    const actionMap = { "+2": "draw2", "skip": "skip", "reverse": "reverse" };
    return `/cards/${initial}_${actionMap[card.name?.toLowerCase()] || card.name}.png`;
  }

  if (card.type === "wild") {
    const wildMap = { "wild": "default", "+4": "draw4" };
    const suffix = wildMap[card.name?.toLowerCase()] || "default";
    
    if (card.color && card.color !== "black" && card.color !== "none") {
      const chosenInitial = colorInitials[card.color.toLowerCase()] || "W";
      return `/cards/${chosenInitial}_${suffix}.png`; 
    }
    
    return `/cards/W_${suffix}.png`; 
  }

  const formatName = (str) => {
    if (!str) return "Unknown";
    return str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join("_");
  };

  if (card.type === "effect") return `/cards/effectCards/${formatName(card.name)}.png`;
  if (card.type === "special") return `/cards/specialCards/${formatName(card.name)}.png`;

  return null;
};

export default function Card({ card, onClick, disabled, width = 120, height = 180 }) {
  const targetPath = getTargetImagePath(card);
  const fallbackPath = "/cards/specialCards/Prototyp01small.png";

  const [imageState, setImageState] = useState(targetPath ? 'target' : 'prototype');

  useEffect(() => {
    setImageState(targetPath ? 'target' : 'prototype');
  }, [card, targetPath]);

  if (!card) {
    return <div style={{ width, height, backgroundColor: "transparent" }} />;
  }

  // Zeigt die Beschreibung an, wenn man die Maus kurz stillhält (nativer Browser Tooltip)
  const tooltipText = (card && card.description) ? `${card.name}: ${card.description}` : "";

  return (
    <div
      onClick={!disabled ? onClick : null}
      title={tooltipText} 
      style={{
        width: width, height: height, cursor: disabled ? "not-allowed" : "pointer",
        position: "relative", overflow: "hidden",
        backgroundColor: "transparent",
        transition: "transform 0.1s",
        transform: !disabled ? "scale(1.0)" : "none",
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        borderRadius: 10
      }}
    >
      {imageState === 'error' && (
        <div style={{
          position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
          display: "flex", justifyContent: "center", alignItems: "center",
          backgroundColor: card.color === "black" ? "#222" : (card.color || "#333")
        }}>
          <h1 style={{ color: "white", margin: 0, textShadow: "0 0 5px black", textAlign: 'center', fontSize: "1.2em", padding: "10px" }}>
            {card.value ?? card.name}
          </h1>
        </div>
      )}

      {imageState !== 'error' && (
        <img
          src={imageState === 'target' ? targetPath : fallbackPath}
          alt={card.name || card.value}
          style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute", top: 0, left: 0 }}
          onError={() => {
            if (imageState === 'target') setImageState('prototype');
            else setImageState('error');
          }}
        />
      )}
    </div>
  );
}